<div class="widget-slider">
  <owl-carousel-o [options]="customOptions">

    <ng-container *ngFor="let image of widget.data.images">
      <ng-template class="slide" carouselSlide>
        <div class="slide-content">
          <app-webp-image
            [src]="getImageUrl(image.url)"
            [alt]="'Das Telemann-Zentrum Magdeburg'"
            [blurhash]="image.blurHash || null">
          </app-webp-image>
        </div>
      </ng-template>
    </ng-container>

  </owl-carousel-o>
</div>
